<template>
    <div class="dropdown">
        <button ref="dropdown" class="erk btn btn-light dropdown-toggle badgeNotification" type="button" id="dropdownMenuButtonNofitication" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-bell fs-2 pe-1 align-middle"></i>
            <span v-if="notificatioonCountNew > 0" class="badge badge-light">{{ notificatioonCountNew }}</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-primary notify-drop" aria-labelledby="dropdownMenuButtonNofitication">
            <div class="notify-drop-title">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-6">Notifiche (<b>{{ notificatioonCountNew }}</b>)</div>
                </div>
            </div>
            <!-- end notify title -->
            <!-- notify content -->
            <div class="drop-content">
                <li v-for="(n, nk) in notifications" :key="nk"
                    :class="{
                        'd-flex': true,
                    }">
                    <div class="col-md-3 col-sm-3 col-xs-3">
                        <div v-if="n.avatar == null" class="notify-img pt-2">
                            <i class="bi bi-info-circle-fill" style="font-size: 52px !important;"></i>
                        </div>
                        <div v-else class="notify-img">
                            <img :src="'/assets/img/avatars/student/' + n.avatar + '.png'" alt=""
                                style="width: 69px;padding-left: 10px;">
                        </div>
                    </div>
                    <div>
                        <div class="p-2">
                            <div class="notify-grid">
                                <div class="notify-grid-item">{{ n.name }}</div>
                                <div class="text-date-epro notify-grid-item text-end me-2">{{ n.date }}</div>
                                <div class="w-100"></div>
                            </div>
                        </div>
                        <p :class="{
                            'lead text-notifyepro': true,
                            'fw-bold': n.isNew
                        }">{{ n.message }}</p>
                    </div>
                </li>
            </div>
            <!--
            <div class="notify-drop-footer text-center">
                <a href="">Mostra tutte</a>
            </div>
            -->
        </ul>
    </div>
</template>
<script>

import axios from 'axios'

export default {
    name: 'MbNoticeWidget',
    data() {
        return {
            notifications: [
            ]
        }
    },
    computed: {
        notificatioonCountNew(){
            if (!this.notifications) return 0

            return this.notifications.filter(n => n.isNew).length
        }
    },
    mounted(){
        this.reload()

        const myDropdown = this.$refs.dropdown
        myDropdown.addEventListener('hidden.bs.dropdown', this.onClose)
    },
    methods: {
        reload(){
            axios.get('/json/notice/NoticeAction-list?outFormat=json').then(response => {
                this.notifications = response.data.result
                setTimeout(() => {
                    this.reload()
                }, 60000)
            })
        },
        onClose(){
            axios.get('/json/notice/NoticeAction-allreaded?outFormat=json').then(() => {
                if (!this.notifications) return

                this.notifications.forEach(n => {
                    n.isNew = false
                })
            })
        }
    }
}

</script>